import React, { useState } from 'react';
import { Lightbulb, TrendingUp, Apple, Droplets, Moon, Heart, Dumbbell, Brain } from 'lucide-react';

const tips = [
  {
    id: 1,
    category: 'nutrition',
    icon: Apple,
    title: 'La règle du 80/20',
    content: 'Mangez sainement 80% du temps, accordez-vous 20% de plaisir. La perfection n\'existe pas, la constance oui !',
    emoji: '🍎',
    color: '#4ade80'
  },
  {
    id: 2,
    category: 'hydratation',
    icon: Droplets,
    title: 'Hydratez-vous correctement',
    content: 'Buvez 2L d\'eau par jour minimum. Astuce : un grand verre dès le réveil stimule votre métabolisme de 30% !',
    emoji: '💧',
    color: '#60a5fa'
  },
  {
    id: 3,
    category: 'sommeil',
    icon: Moon,
    title: 'Le sommeil, votre allié',
    content: '7-9h de sommeil = meilleure récupération, moins de fringales, plus d\'énergie. Ne négligez jamais votre sommeil !',
    emoji: '🌙',
    color: '#a78bfa'
  },
  {
    id: 4,
    category: 'sport',
    icon: Dumbbell,
    title: 'Bougez un peu chaque jour',
    content: '30 minutes d\'activité par jour suffisent ! Marche, vélo, escaliers... Chaque mouvement compte.',
    emoji: '💪',
    color: '#f97316'
  },
  {
    id: 5,
    category: 'mental',
    icon: Brain,
    title: 'La force du mental',
    content: 'Vous n\'êtes pas au régime, vous changez de vie. Chaque bon choix vous rapproche de la meilleure version de vous-même !',
    emoji: '🧠',
    color: '#ec4899'
  },
  {
    id: 6,
    category: 'nutrition',
    icon: Apple,
    title: 'Les protéines, vos alliées',
    content: 'Les protéines rassasient et préservent vos muscles. Visez 1,6g à 2g par kg de poids corporel.',
    emoji: '🥩',
    color: '#4ade80'
  },
  {
    id: 7,
    category: 'habitudes',
    icon: TrendingUp,
    title: 'Les petites victoires comptent',
    content: 'Célébrez chaque progrès ! Un légume en plus, une marche de 10 min, un verre d\'eau... Tout compte !',
    emoji: '🏆',
    color: '#fbbf24'
  },
  {
    id: 8,
    category: 'nutrition',
    icon: Apple,
    title: 'Préparez vos repas',
    content: 'La préparation du dimanche = succès de la semaine. Cuisinez à l\'avance pour éviter les mauvais choix.',
    emoji: '📦',
    color: '#4ade80'
  },
  {
    id: 9,
    category: 'mental',
    icon: Heart,
    title: 'Soyez patient(e)',
    content: 'Les vrais résultats prennent du temps. Concentrez-vous sur les habitudes, pas sur la balance.',
    emoji: '❤️',
    color: '#ec4899'
  },
  {
    id: 10,
    category: 'nutrition',
    icon: Apple,
    title: 'Les fibres sont magiques',
    content: 'Légumes, fruits, céréales complètes... Les fibres rassasient longtemps et régulent votre digestion.',
    emoji: '🥬',
    color: '#4ade80'
  }
];

const TipsPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [expandedTip, setExpandedTip] = useState(null);

  const categories = [
    { id: 'all', label: 'Tous', emoji: '✨' },
    { id: 'nutrition', label: 'Nutrition', emoji: '🍎' },
    { id: 'hydratation', label: 'Hydratation', emoji: '💧' },
    { id: 'sommeil', label: 'Sommeil', emoji: '🌙' },
    { id: 'sport', label: 'Sport', emoji: '💪' },
    { id: 'mental', label: 'Mental', emoji: '🧠' },
    { id: 'habitudes', label: 'Habitudes', emoji: '🏆' }
  ];

  const filteredTips = activeCategory === 'all' 
    ? tips 
    : tips.filter(t => t.category === activeCategory);

  return (
    <div className="tips-page">
      <div className="page-header">
        <div>
          <h1>💡 Conseils Nutrition</h1>
          <p>Des conseils validés par la science pour réussir votre transformation !</p>
        </div>
      </div>

      <div className="tips-categories">
        {categories.map(cat => (
          <button
            key={cat.id}
            className={`category-pill ${activeCategory === cat.id ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat.id)}
          >
            <span className="cat-emoji">{cat.emoji}</span>
            {cat.label}
          </button>
        ))}
      </div>

      <div className="tips-grid">
        {filteredTips.map(tip => (
          <div 
            key={tip.id} 
            className={`tip-card ${expandedTip === tip.id ? 'expanded' : ''}`}
            onClick={() => setExpandedTip(expandedTip === tip.id ? null : tip.id)}
            style={{ '--tip-color': tip.color }}
          >
            <div className="tip-header">
              <div className="tip-icon" style={{ background: tip.color }}>
                <tip.icon size={24} />
              </div>
              <span className="tip-emoji">{tip.emoji}</span>
            </div>
            <h3>{tip.title}</h3>
            <p>{tip.content}</p>
            <div className="tip-category-badge" style={{ color: tip.color }}>
              {categories.find(c => c.id === tip.category)?.label}
            </div>
          </div>
        ))}
      </div>

      <div className="tips-motivation">
        <Lightbulb size={32} />
        <h3>Un conseil par jour...</h3>
        <p>Chaque petit pas vous rapproche de vos objectifs. Continuez comme ça, vous gérez !</p>
      </div>
    </div>
  );
};

export default TipsPage;
